import { request } from "./request";
import Cookies from "js-cookie";
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, AD_ID_COOKIES_KEY } from "@/utils/constant";
import { getAppID, getFbPixelId, setUserInfo, getUserInfo } from '@/utils/base'
import { getParam, getStorage } from '@/utils/tools'
import { getRandomString } from "@/utils/paypal";

export const fetchGetRankingList = function (data) {
  return request({
    url: "/api/v1/pay_books/ranking",
    method: "post",
    data
  })
}

export const fetchGetHomeList = function (data) {
  return request({
    url: "/api/v1/pay_books/list",
    method: "post",
    data,
  })
}

export const fetchGetSearchList = function (data) {
  return request({
    url: "/api/v1/pay_books/search",
    method: "post",
    data,
  })
}

export const fetchGetTmpUuid = function (data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/api/v1/user/tmp_register",
      method: "post",
      isToast: false,
      data:{
        app_id:getAppID(),
        user_type:0
      },
    }).then(response => {
      // Cookies.set(USER_ID_COOKIES_KEY, response.token_info.user_id, { expires: 365 })
      // Cookies.set(USER_TOKEN_COOKIES_KEY, response.token_info.accessToken, { expires: 365 })
      setUserInfo(response.token_info.user_id, response.token_info.accessToken)
      resolve(response)
    })
  })
}

export const fetchGetFavbookList = function (data) {
  return request({
    url: "/api/v1/pay_books/favbook_list",
    method: "post",
    data,
  })
}

export const fetchRegister = function (data) {
  return request({
    url: "/api/v1/user/register",
    method: "post",
    data,
  })
}

export const fetchLogin = function (data) {
  return request({
    url: "/api/v1/user/login",
    method: "post",
    data,
  })
}

export const fetchGetBookDetail = function (data) {
  return request({
    url: "/api/v1/pay_books/detail",
    method: "post",
    data,
  })
}

export const fetchAddFavbook = function (data) {
  return request({
    url: "/api/v1/pay_books/favbook",
    method: "post",
    data,
  })
}

export const fetchGetBookChapterList = function (data) {
  return request({
    url: "/api/v1/pay_chapter/list",
    method: "post",
    data,
  })
}

export const fetchGetChapterInfo = function (data) {
  return request({
    url: "/api/v1/pay_chapter/info",
    method: "post",
    data,
  })
}

// 获取档位列表
export const fetchGearList = function (data) {
  return request({
    url: "/api/v1/order/purchase_list",
    method: "post",
    data,
  })
}


export const fetchOrderSubmit = function (data) {
  return request({
    url: "/api/v1/alipay/submit",
    method: "post",
    isToast: false,
    responseType: 'all',
    data: {
      cid: getParam('pid') || '130500',
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchPaypalAppleCapture = function (data){
  return request({
    url: '/api/v1/order/applepaypalcapture',
    method: 'post',
    data: {
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchGetUserDetail = function (data) {
  return request({
    url: "/api/v1/user/detail",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data,
  })
}

export const fetchFbReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      fbid: getFbPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      fbp: Cookies.get('_fbp') || "",
      fbc: Cookies.get('_fbc') || "",
    },
    ...data
  }
  if(obj.event === 'pixel_report'){
    if(type === 'PageView'){
      console.log('PageView', getFbPixelId())
      window.fbq('init', getFbPixelId()); 
      window.fbq('track', 'PageView');
    }
  }

  return request({
    url: "/api/v1/report/fb",
    method: "post",
    isToast: false,
    data: {
      ...obj
    },
  })
}

// 埋点统计上报
export const fetchReportEvent = function (data) {
  return request({
    url: "/api/v1/data/receive",
    method: "post",
    isToast: false,
    data: {
      app_id: getAppID(),
      user_id: getUserInfo().user_id,
      idfp: Cookies.get(AD_ID_COOKIES_KEY) || '', // 传 ad_id
      ...data
    },
  })
}